import type { ProgressionState } from "@craftgaming/shared";

export type XpBar = {
  update: (state: ProgressionState) => void;
  showLevelUp: (level: number) => void;
  dispose: () => void;
};

export function createXpBar(): XpBar {
  const container = document.createElement("div");
  container.id = "xp-bar";
  container.style.cssText = `
    position: absolute;
    bottom: 66px;
    left: 50%;
    transform: translateX(-50%);
    width: 450px;
    pointer-events: none;
  `;

  // Bar background
  const barBg = document.createElement("div");
  barBg.style.cssText = `
    width: 100%;
    height: 4px;
    background: #1a1a2e;
    border-radius: 2px;
    overflow: hidden;
  `;

  const barFill = document.createElement("div");
  barFill.style.cssText = `
    height: 100%;
    width: 0%;
    background: linear-gradient(90deg, #4ade80, #22d3ee);
    border-radius: 2px;
    transition: width 0.3s;
  `;
  barBg.appendChild(barFill);
  container.appendChild(barBg);

  // Level badge (centered on bar)
  const levelBadge = document.createElement("div");
  levelBadge.style.cssText = `
    position: absolute;
    top: -8px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 9px;
    font-weight: bold;
    color: #4ade80;
    font-family: monospace;
    text-shadow: 0 0 4px rgba(74,222,128,0.5);
  `;
  levelBadge.textContent = "1";
  container.appendChild(levelBadge);

  // Level up popup
  const levelUpPopup = document.createElement("div");
  levelUpPopup.style.cssText = `
    position: fixed;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 2rem;
    font-weight: bold;
    color: #4ade80;
    text-shadow: 0 0 10px rgba(74,222,128,0.5);
    opacity: 0;
    transition: opacity 0.3s, transform 0.3s;
    pointer-events: none;
    z-index: 50;
    font-family: 'Segoe UI', system-ui, sans-serif;
  `;
  document.body.appendChild(levelUpPopup);

  const overlay = document.getElementById("ui-overlay");
  if (overlay) overlay.appendChild(container);

  function update(state: ProgressionState) {
    const percent = (state.xp / state.xpToNextLevel) * 100;
    barFill.style.width = `${percent}%`;
    levelBadge.textContent = `${state.level}`;
  }

  function showLevelUp(level: number) {
    levelUpPopup.textContent = `LEVEL UP! → ${level}`;
    levelUpPopup.style.opacity = "1";
    levelUpPopup.style.transform = "translateX(-50%) translateY(-10px)";

    setTimeout(() => {
      levelUpPopup.style.opacity = "0";
      levelUpPopup.style.transform = "translateX(-50%) translateY(0)";
    }, 2500);
  }

  function dispose() {
    container.remove();
    levelUpPopup.remove();
  }

  return { update, showLevelUp, dispose };
}
